import React,{Component} from 'react';
import { connect } from 'react-redux';
import { Modal } from "react-bootstrap";
//import Authentication from '../../services/authentication/Authentication';
//import {isAuthenticated} from '../services/authentication/Authentication';
import { login } from '../../actions/userAction';
import { errorMessage,mediaPath } from '../../config';

class Login extends Component {
	constructor(props, context) {
		super(props, context);
			if(props.location.state!=undefined)
			{
				this.pathname =  props.location.state.from.pathname;
			}

		this.state = {
			loginForm:{
				email:'',
				user_password:'',
				emailValid: true
			},
			submitted: false,
		}
	}
	updateLoginForm(data){
		this.setState({
			loginForm:{
				...this.state.loginForm,
				...data
		},},
			() => { this.validateField(data) }
			
		)
		this.setState({submitted:false});
	}
	
	validateField(data) {
		this.state.submitted = false;
		let emailId = data.email;
		if(emailId!=undefined && emailId!='')
		{
			this.state.loginForm.emailValid = false;
			let result = emailId.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
			if(result)
			{
				this.state.loginForm.emailValid = true;
			}
		}
	}
	
	submitOnEnter = (e) => {
		if(e.key === 'Enter'){
			this.validateLoginForm();
		}
	}
	validateLoginForm(){
		this.setState({submitted:true});
		if(this.state.loginForm.email&&this.state.loginForm.user_password&&this.state.loginForm.emailValid){
			this.props.login(this.state.loginForm,this.pathname,this.params);
		}
	}
	/* Function is used to close the modal */
	handleClose() {
		this.props.showHideNotificationModal(false);
	}
  componentDidMount() {
		if(this.props.match.params.caseid!="" && this.props.match.params.caseid!=undefined){
			this.params =this.props.match.params;
		}
	}
	render(){
		return (
			<div role="main">
				<div className="login-block">
					<div className="login-inner-wrapper">
						<div className="logo"><a onClick={()=>{
										this.props.history.push('/login');
									}}><img src={mediaPath+"osah-logo.png"} alt="OSAH Georgia office of state administrative hearings"/></a></div>
							<div className="login-section">
								<p className="already-have-account">Already have an account?</p>
								<h1 className="title" aria-label="Login">LOGIN</h1>
								<div className="username-block">
									<label>Email Address *
										<input aria-required="true" type="text" id="email" onChange={(e)=>this.updateLoginForm({email:e.target.value.trim()})} onKeyPress={(e)=>{this.submitOnEnter(e)}}/>
									</label>
								</div>
								<div className="password-block">
									<label>Password *
										<input aria-required="true" id="password" type="password" id="password" onChange={(e)=>this.updateLoginForm({user_password:e.target.value.trim()})} onKeyPress={(e)=>{this.submitOnEnter(e)}}/>
									</label>
								</div>
								<span className="error">
									{this.state.submitted && !(this.state.loginForm.email&&this.state.loginForm.user_password)&&
										<p>Please enter {!this.state.loginForm.email?'an email address for your username':''}  {(!this.state.loginForm.email&&!this.state.loginForm.user_password)?'and':''} {!this.state.loginForm.user_password?'your password':''}!</p>
									}
									{this.state.submitted && this.state.loginForm.email && this.state.loginForm.user_password && !this.state.loginForm.emailValid && <p>Please enter a valid email address.</p>}
									
									{/* {this.state.submitted && this.props.authenticate===false &&
									(this.state.loginForm.email&&this.state.loginForm.user_password&& this.state.loginForm.emailValid)&&
										<p>{errorMessage.authenticationFailed}</p>
									} */}
									
									

									{this.state.submitted && this.props.errorFlag==='logatt' &&
									(this.state.loginForm.email&&this.state.loginForm.user_password&& this.state.loginForm.emailValid)&&
										<p>{errorMessage.loginAttempt}</p>
									}
									
									{this.state.submitted && this.props.errorFlag==='locked' &&
									(this.state.loginForm.email&&this.state.loginForm.user_password&& this.state.loginForm.emailValid)&&
										<p>{errorMessage.lockedAcc}</p>
									}
								</span>
								<p className="forgot-password"><a href="javascript:;" onClick={()=>{
									this.props.history.push('/forgotPassword');
								}}>Forgot Password?</a></p>
								<div className="btn-block">
									<button onClick={() => this.validateLoginForm() } className="login-btn ripple">Login</button>
								</div>
								<p className="create-account">Don't have an account? <a href="javascript:;" onClick={()=>{
									this.props.history.push('/createaccount');
								}}>Create Account</a></p>
								<p className="tcpp">By continuing to use our site, you agree to our <a className="notice-link" href="https://eportal.osah.ga.gov/eService requirements/ePortal Terms and Conditions_2019_09_04.pdf" target="_blank">Terms & Conditions</a> and <a className="notice-link" href="https://eportal.osah.ga.gov/eService requirements/OSAH Privacy Policy_2019_08_26.pdf" target="_blank">Privacy Policy</a>.</p>
							</div>
					</div>
				</div>
			</div>
		)
	}
	componentDidUpdate(){

	}
}
function mapStateToProps(state) {
	return {authenticate:state.userData,errorFlag:state.userData.details.errmsg};
}
export default connect(mapStateToProps, {login})(Login);